import { cn } from '@repo/utils/cn';
import LanguageButtonWrapper from '@/components/common/language-button-wrapper';
import VatanCoinPrice from '@/components/common/vatan-coin-price';
import Affiliates from '@/components/layout/sidebar-left/affiliates';
import Casino from '@/components/layout/sidebar-left/casino';
import CrashGames from '@/components/layout/sidebar-left/crash-games';
import Favorites from '@/components/layout/sidebar-left/favorites';
import LiveDealer from '@/components/layout/sidebar-left/live-dealer';
import LiveSupport from '@/components/layout/sidebar-left/live-support';
import PopularGames from '@/components/layout/sidebar-left/popular-games';
import ProductCategories from '@/components/layout/sidebar-left/product-categories';
import Search from '@/components/layout/sidebar-left/search';
import Sports from '@/components/layout/sidebar-left/sports';

// import { env } from '@/lib/env';
// import Challenges from './challenges';

type SidebarContentProps = {
  isBottomMenu?: boolean;
  sidebarOpen: boolean;
  isAuthenticated?: boolean;
  activeSidebarSection: 'CASINO' | 'SPORTS' | null;
  setActiveSidebarSection: (section: 'CASINO' | 'SPORTS' | null) => void;
};

const SidebarContent = ({
  isBottomMenu,
  sidebarOpen,
  isAuthenticated,
  activeSidebarSection,
  setActiveSidebarSection,
}: SidebarContentProps) => {
  return (
    <section className={cn('flex h-full flex-col gap-10 p-2.5', isBottomMenu && 'px-0 py-4')}>
      {!sidebarOpen && <ProductCategories />}
      <div className="flex flex-col gap-10">
        {!isBottomMenu && <Search sidebarOpen={sidebarOpen} />}
        {(isBottomMenu || sidebarOpen) && <VatanCoinPrice />}
      </div>

      <div className="flex flex-col gap-1.5">
        {isAuthenticated && <Favorites sidebarOpen={sidebarOpen} />}
        <Casino
          sidebarOpen={sidebarOpen}
          isActive={activeSidebarSection === 'CASINO'}
          onClick={() => setActiveSidebarSection(activeSidebarSection === 'CASINO' ? null : 'CASINO')}
        />
        <Sports
          sidebarOpen={sidebarOpen}
          isActive={activeSidebarSection === 'SPORTS'}
          onClick={() => setActiveSidebarSection(activeSidebarSection === 'SPORTS' ? null : 'SPORTS')}
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <LiveDealer sidebarOpen={sidebarOpen} />
        <PopularGames sidebarOpen={sidebarOpen} />
        <CrashGames sidebarOpen={sidebarOpen} />
      </div>

      <div className="flex flex-col gap-1.5">
        <Affiliates
          sidebarOpen={sidebarOpen}
          isAuthenticated={isAuthenticated}
        />
      </div>

      {/* DO NOT ALLOW YET IN PRODUCTION */}
      {/* {env.VERCEL_ENV !== 'production' && isAuthenticated && (
        <div className="flex flex-col gap-1.5">
          <Challenges
            sidebarOpen={sidebarOpen}
            isAuthenticated={isAuthenticated}
          />
        </div>
      )} */}

      {/* Spacer to push the bottom section down */}
      <div className="flex-grow" />

      {/* Bottom Section: always at the bottom */}
      <div className="flex flex-col gap-1.5">
        <LiveSupport sidebarOpen={sidebarOpen} />
        <LanguageButtonWrapper
          showFlag
          variant="sidebar"
          withFullName={sidebarOpen}
        />
      </div>
    </section>
  );
};

export default SidebarContent;
